import { useState, useEffect, type ChangeEvent, type MouseEvent, type FormEvent } from "react";
import Modal from "@modalSrc/Modal";

type DuplicateTestTypeNameModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onDuplicate: (name: string) => Promise<void>;
  isDuplicating?: boolean;
  zIndex?: number;
};

export default function DuplicateTestTypeNameModal({
  isOpen,
  onClose,
  onDuplicate,
  isDuplicating = false,
  zIndex,
}: DuplicateTestTypeNameModalProps) {
  const [newName, setNewName] = useState("");

  useEffect(() => {
    if (isOpen) {
      setNewName("");
    }
  }, [isOpen]);

  async function handleSubmit(e: FormEvent<HTMLFormElement> | MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    if (!newName.trim() || isDuplicating) return;
    await onDuplicate(newName.trim());
  }

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Duplicate Test Type"
      size="sm"
      zIndex={zIndex}
      footer={(
        <>
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={isDuplicating}>Cancel</button>
          <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={!newName.trim() || isDuplicating}>
            {isDuplicating ? "Duplicating..." : "Duplicate"}
          </button>
        </>
      )}
    >
      <form id="duplicate-test-type-form" onSubmit={handleSubmit}>
        <label htmlFor="duplicate-test-type-name">New Test Type Name</label>
        <input
          id="duplicate-test-type-name"
          type="text"
          value={newName}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setNewName(e.target.value)}
          autoFocus
          required
        />
      </form>
    </Modal>
  );
}
